import { render } from "./modal-send-invoices.vue?vue&type=template&id=49562990"
import script from "./modal-send-invoices.vue?vue&type=script&lang=js"
export * from "./modal-send-invoices.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__